export const DEFAULT_GROUP_ID = 1;
export const DEFAULT_EXPORT_TYPE = 1;

export const GROUPS = {
  Student: 1,
  Recipe: 2,
  Ingredient: 3,
};

export const StudentStatusOptions = [
  { label: 'Active', value: 0 },
  { label: 'Both', value: 1 },
  { label: 'Inactive', value: 2 },
];

export const RecipeStatusOptions = [
  { label: 'Local', value: 0 },
  { label: 'USDA', value: 1 },
  { label: 'All', value: 2 },
];

export const IngredientStatusOptions = [
  { label: 'Local', value: 0 },
  { label: 'USDA', value: 1 },
  { label: 'All', value: 2 },
];

export const GroupStatusOptions = {
  [GROUPS.Student]: StudentStatusOptions,
  [GROUPS.Recipe]: RecipeStatusOptions,
  [GROUPS.Ingredient]: IngredientStatusOptions,
};

export const GroupStatusLabels = {
  [GROUPS.Student]: 'Active or Inactive Students',
  [GROUPS.Recipe]: 'Local or USDA Recipes',
  [GROUPS.Ingredient]: 'Local or USDA Ingredients',
};



// WEBPACK FOOTER //
// ./src/pages/universaldataexport/helpers/constants.js